export function useUserLocation() {
  const coords = ref<{ lat: number; lng: number } | null>(null);
  const permissionGranted = ref(false);
  const permissionDenied = ref(false);

  function requestLocation() {
    if (!navigator.geolocation) {
      permissionDenied.value = true;
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        coords.value = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        permissionGranted.value = true;
      },
      () => {
        permissionDenied.value = true;
      }
    );
  }

  return {
    coords,
    permissionGranted,
    permissionDenied,
    requestLocation,
  };
}
